<template lang="html">
  <table :style='styles.headerTable'>
    <tr
      v-for='record in data'
      :style='styles.trStyle'>
      <th
        :class='styles.headerTableTdClasses.primaryGreenBg'
        :rowspan='record.parent_span'
        v-if='record.parent'
        :style='styles.thStyle'
      >
      {{ record.parent }}
      </th>
      <th
        :class='styles.headerTableTdClasses.darkGreenBg'
        :style='styles.thStyle'
      >
      {{ record.name }}
      </th>
    </tr>
  </table>
</template>

<script>
export default {
  props: ['data', 'styles'],
  data () {
    return {
      tableInstance: null,
      table: null
    }
  }
}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// VerticalHeaderTable.vue?5b0fa5bc